/**
 * HistoryTab - Time series charts and scan log (refactored from MonitoringCharts)
 * Reuses existing MonitoringCharts component as the core functionality
 */
import { FC } from 'react';
import { MonitoredUrl, FlattenedMonitoringHistory } from '../../../types';
import { MonitoringCharts } from '../MonitoringCharts';
import type { UserType } from '../../../lib/auth/types';

interface HistoryTabProps {
    history: FlattenedMonitoringHistory[];
    fieldDataHistory: any[]; // Field data from additional_metrics.field_data_history
    selectedUrl: MonitoredUrl | null;
    monitoringUsage?: any;
    user?: { uid: string; email: string | null; user_type?: UserType } | null;
}

export const HistoryTab: FC<HistoryTabProps> = ({ history, fieldDataHistory, selectedUrl, monitoringUsage, user }) => {
    // Simply wrap the existing MonitoringCharts component
    // This preserves all existing functionality (Average View, Time Series)
    return (
        <MonitoringCharts
            history={history}
            selectedUrl={selectedUrl}
            monitoringUsage={monitoringUsage}
            user={user}
        />
    );
};

export default HistoryTab;
